import type ModalService from "./modalService";
import type AdHocReportsProcessedViewModel from "viewModels/timeCharges/reporting/adHocReports/adHocReportsProcessedViewModel";
import type AdHocReportsFinishedViewModel from "viewModels/timeCharges/reporting/adHocReports/adHocReportsFinishedViewModel";

export default class AdhocReportsService {
  constructor(
    private modalService: ModalService,
    private adHocReportsProcessedViewModelFactory: ReturnType<typeof AdHocReportsProcessedViewModel.Factory>,
    private adHocReportsFinishedViewModelViewModelFactory: ReturnType<typeof AdHocReportsFinishedViewModel.Factory>
  ) {}

  public async showProcessedConfirmation() {
    const viewModel = this.adHocReportsProcessedViewModelFactory();
    await this.modalService.tryActivateChild(viewModel);
    const { confirmed, generate } = await viewModel.showConfirmation();
    this.modalService.closeChild(viewModel);
    return { confirmed, generate };
  }
  public async showFinishedConfirmation() {
    const viewModel = this.adHocReportsFinishedViewModelViewModelFactory();
    await this.modalService.tryActivateChild(viewModel);
    const { confirmed, generate } = await viewModel.showConfirmation();
    this.modalService.closeChild(viewModel);
    return { confirmed, generate };
  }
}
